import React, { useEffect, FC } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

const ScrollToTop: FC<RouteComponentProps> = ({ history, children }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return <>{children}</>;
};

export default withRouter(ScrollToTop);
